<template>
    <component :is="chartComponent" :height="height" :chart-data="settings.data" :options="settings.options"></component>
</template>

<script>
    import LineChart from './line.chart.vue';
    import PieChart from './pie.chart.vue';

    export default {
        name: 'CommonChart',
        props: {
            settings: {
                default: {
                    type: 'line',
                    data: {},
                    options: {}
                }
            }
        },

        data(){
            return {

            }
        },
        mounted(){

        },
        computed: {
            chartComponent(){
                const map = {
                    line: LineChart,
                    pie: PieChart,
                };
                return map[this.settings.type];
            },
            height(){
                return this.settings && this.settings.height ? this.settings.height : 250;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/stats/charts/common/common.chart.vue